var _ellipse, _g, _ellipse2, _rect, _g2, _g3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylistEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 347,
    viewBox: "0 0 425 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.18,
    filter: "url(#filter0_f_4_11877)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.657,
    cy: 123.507,
    rx: 71.867,
    ry: 70.5836,
    fill: "#49E0B3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter1_f_4_11877)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.745,
    cy: 162.81,
    r: 68.0169,
    fill: "#190DA0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.43,
    filter: "url(#filter2_f_4_11877)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.426,
    cy: 180.736,
    rx: 84.7003,
    ry: 84.0587,
    fill: "#5B4B9B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.34,
    y: 89.5059,
    width: 167.117,
    height: 167.117,
    rx: 83.5587,
    fill: "url(#paint0_linear_4_11877)",
    stroke: "url(#paint1_linear_4_11877)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.81 191.645V209.612",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.826 200.629H358.793",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.41 227.472V237.952",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.17 232.712H339.65",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.349 59.6354V97.8147",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.259 78.7252H141.438",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4_11877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.8676,
    y: 127.193,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_11877)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 95.8676,
    y: 134.481,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#B2D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 149.69C105 149.309 105.344 149 105.769 149L127.231 149C127.656 149 128 149.309 128 149.69C128 150.071 127.656 150.38 127.231 150.38L105.769 150.38C105.344 150.38 105 150.071 105 149.69ZM119.711 153.29C119.96 153.169 120.262 153.181 120.499 153.319L127.652 157.526C127.869 157.654 128 157.871 128 158.103C128 158.336 127.869 158.553 127.652 158.681L120.499 162.887C120.262 163.026 119.96 163.038 119.711 162.917C119.463 162.797 119.308 162.563 119.308 162.31V153.897C119.308 153.643 119.463 153.41 119.711 153.29ZM105 153.897C105 153.516 105.344 153.207 105.769 153.207H115.308C115.733 153.207 116.077 153.516 116.077 153.897C116.077 154.278 115.733 154.587 115.308 154.587H105.769C105.344 154.587 105 154.278 105 153.897ZM120.846 155.174V161.032L125.827 158.103L120.846 155.174ZM105 158.103C105 157.722 105.344 157.413 105.769 157.413H112.923C113.348 157.413 113.692 157.722 113.692 158.103C113.692 158.484 113.348 158.793 112.923 158.793H105.769C105.344 158.793 105 158.484 105 158.103ZM105 162.31C105 161.929 105.344 161.62 105.769 161.62H109.346C109.771 161.62 110.115 161.929 110.115 162.31C110.115 162.691 109.771 163 109.346 163H105.769C105.344 163 105 162.691 105 162.31Z",
    fill: "#65AAA3"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 147.868,
    y: 152.481,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4_11877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.411,
    y: 78.3965,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 198.411,
    y: 85.6843,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 100.69C208 100.309 208.344 100 208.769 100L230.231 100C230.656 100 231 100.309 231 100.69C231 101.071 230.656 101.38 230.231 101.38L208.769 101.38C208.344 101.38 208 101.071 208 100.69ZM222.711 104.29C222.96 104.169 223.262 104.181 223.499 104.319L230.652 108.526C230.869 108.654 231 108.871 231 109.103C231 109.336 230.869 109.553 230.652 109.681L223.499 113.887C223.262 114.026 222.96 114.038 222.711 113.917C222.463 113.797 222.308 113.563 222.308 113.31V104.897C222.308 104.643 222.463 104.41 222.711 104.29ZM208 104.897C208 104.516 208.344 104.207 208.769 104.207H218.308C218.733 104.207 219.077 104.516 219.077 104.897C219.077 105.278 218.733 105.587 218.308 105.587H208.769C208.344 105.587 208 105.278 208 104.897ZM223.846 106.174V112.032L228.827 109.103L223.846 106.174ZM208 109.103C208 108.722 208.344 108.413 208.769 108.413H215.923C216.348 108.413 216.692 108.722 216.692 109.103C216.692 109.484 216.348 109.793 215.923 109.793H208.769C208.344 109.793 208 109.484 208 109.103ZM208 113.31C208 112.929 208.344 112.62 208.769 112.62H212.346C212.771 112.62 213.115 112.929 213.115 113.31C213.115 113.691 212.771 114 212.346 114H208.769C208.344 114 208 113.691 208 113.31Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.411,
    y: 103.684,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_4_11877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.227,
    y: 189.426,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 131.227,
    y: 196.714,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#F3DF9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 211.69C140 211.309 140.344 211 140.769 211L162.231 211C162.656 211 163 211.309 163 211.69C163 212.071 162.656 212.38 162.231 212.38L140.769 212.38C140.344 212.38 140 212.071 140 211.69ZM154.711 215.29C154.96 215.169 155.262 215.181 155.499 215.319L162.652 219.526C162.869 219.654 163 219.871 163 220.103C163 220.336 162.869 220.553 162.652 220.681L155.499 224.887C155.262 225.026 154.96 225.038 154.711 224.917C154.463 224.797 154.308 224.563 154.308 224.31V215.897C154.308 215.643 154.463 215.41 154.711 215.29ZM140 215.897C140 215.516 140.344 215.207 140.769 215.207H150.308C150.733 215.207 151.077 215.516 151.077 215.897C151.077 216.278 150.733 216.587 150.308 216.587H140.769C140.344 216.587 140 216.278 140 215.897ZM155.846 217.174V223.032L160.827 220.103L155.846 217.174ZM140 220.103C140 219.722 140.344 219.413 140.769 219.413H147.923C148.348 219.413 148.692 219.722 148.692 220.103C148.692 220.484 148.348 220.793 147.923 220.793H140.769C140.344 220.793 140 220.484 140 220.103ZM140 224.31C140 223.929 140.344 223.62 140.769 223.62H144.346C144.771 223.62 145.115 223.929 145.115 224.31C145.115 224.691 144.771 225 144.346 225H140.769C140.344 225 140 224.691 140 224.31Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.227,
    y: 214.714,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_11877",
    x: 24.7899,
    y: 0.923828,
    width: 247.734,
    height: 245.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_4_11877"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_11877",
    x: 124.728,
    y: 12.793,
    width: 300.034,
    height: 300.034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_4_11877"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4_11877",
    x: 0.725464,
    y: 14.6777,
    width: 333.401,
    height: 332.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_4_11877"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4_11877",
    x: 65.8676,
    y: 112.193,
    width: 216.799,
    height: 96.5757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_11877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_11877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4_11877",
    x: 168.411,
    y: 63.3965,
    width: 216.799,
    height: 96.5757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_11877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_11877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_4_11877",
    x: 101.227,
    y: 174.426,
    width: 216.799,
    height: 96.5757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_11877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_11877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_11877",
    x1: 59.5933,
    y1: -15.3281,
    x2: 381.793,
    y2: 116.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_11877",
    x1: 146.411,
    y1: 108.938,
    x2: 263.195,
    y2: 241.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFE2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5BFF",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_11877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(95.8676 134.481)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistEmpty);
export default __webpack_public_path__ + "static/media/playlist_empty.a2e9834e7b8363ec425b0f89efd0bbb4.svg";
export { ForwardRef as ReactComponent };